import React, { useMemo } from 'react';
import IContext from '../shared/types/multiSelectContext';
import IMultiSelectProvider from '../shared/types/multiSelectProvider';
import IMultiSelectOption from '../shared/types/multiSelectOption';

const MultiSelectContext = React.createContext({} as IContext);

export function useMultiSelect() {
    return React.useContext(MultiSelectContext);
}

export default function MultiSelectProvider({
    name,
    value: selectedOptions = [],
    options,
    onChange,
    children
}: IMultiSelectProvider) {
    /* Select option method */
    const selectOption = (option: IMultiSelectOption) => onChange([option, ...selectedOptions]);

    /* Delselect option method */
    const deselectOption = (option: IMultiSelectOption) =>
        onChange(selectedOptions.filter((selectedValue: IMultiSelectOption) => selectedValue.value !== option.value));

    /* check if options is selected method */
    const isSelected = (option: IMultiSelectOption): boolean =>
        selectedOptions.some((selectedValue) => selectedValue.value === option.value);

    /* Toggle option method */
    const toggleOption = (option: IMultiSelectOption) => {
        if (isSelected(option)) {
            return deselectOption(option);
        }
        return selectOption(option);
    };

    const context = useMemo(
        () => ({
            name,
            options,
            selectedOptions,
            selectOption,
            deselectOption,
            toggleOption,
            isSelected
        }),
        [selectedOptions]
    );

    return <MultiSelectContext.Provider value={context}>{children}</MultiSelectContext.Provider>;
}
